import { useEffect, useState } from 'react';
import Header from 'src/components/demo-day/header/Header';
import cx from '../demo-day/index.module.scss';
import styles from '../demo-day-register/index.module.scss';
import { findingBrilliantIcon, loginlogo } from 'src/assets/images';
import Stepper from 'src/components/demo-day-register/Stepper/Stepper';
import { Loader, TStep } from 'src/components/common';
import Register from 'src/components/demo-day-register/register/Register';
import { clearDemoDay, clearMyVenture, getDemoDay, getVentureCounters } from 'src/store/venture/venture.slice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useGetIdentity, useUrlParamValue } from 'src/hooks';
import SubmitPitchDeck from 'src/components/demo-day-register/submit-pitch-deck/SubmitPitchDeck';
import { useNavigate } from 'react-router-dom';
const DemoDayDocumentSubmission = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { ventureLoading, demoDay } = useAppSelector(
        (store) => store.venture
    );
    const { paramValue } = useUrlParamValue();

    const ventureVerseId: string = paramValue({ paramName: 'id' }) as string;
    const steps: TStep[] = [
        { label: 'Register' },
        { label: 'Pitch Deck' },
        { label: 'Book A Slot' }
    ];

    useEffect(() => {
        if (ventureVerseId) {
            dispatch(getDemoDay({ ventureVerseId }))
        } else {
            navigate('/demo-day')
        }
        return () => {
            dispatch(clearDemoDay())
        }
    }, [ventureVerseId]);
    return (
        <div className={cx.demoDay}>
            <Header />
            <div className={cx.demoDayContent}>
                <section className={styles.content}>
                    {!ventureLoading && demoDay && <div className={styles.container}>
                        <div className={styles.left}>
                            <img src={findingBrilliantIcon} alt="finding-logo" />
                        </div>
                        <div className={styles.right}>
                            <Stepper
                                currentStep={1}
                                steps={steps}
                            />
                            <SubmitPitchDeck key="pitch-deck" />
                        </div>
                    </div>}
                    {ventureLoading && (
                        <div className="pt-5">
                            <Loader />
                        </div>
                    )}
                </section>
            </div>
        </div>
    );
};

export default DemoDayDocumentSubmission;
